/* Twinkle Christmas — custom theme script.
   Runs the same in the static preview (mock cart) and in Shopify (Cart AJAX API). */
(function () {
  'use strict';

  var TWK = window.TWK || {};
  var S = TWK.settings || {};
  var T = TWK.i18n || {};
  var R = TWK.routes || { cart_add: '/cart/add', cart_change: '/cart/change', cart: '/cart', checkout: '/checkout' };
  var PREVIEW = TWK.mode !== 'shopify';
  var RATE = parseFloat(S.rate || (window.Shopify && Shopify.currency && Shopify.currency.rate) || 1) || 1;
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  function t(key, vars, fallback) {
    var s = T[key] != null ? T[key] : (fallback || key);
    if (vars) Object.keys(vars).forEach(function (k) { s = s.split('{' + k + '}').join(vars[k]); });
    return s;
  }

  /* ---------- Money (Shopify money_format) ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    format = (format || '€{{amount}}').replace(/<[^>]*>/g, '');
    function delimit(number, precision, thousands, decimal) {
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    var m = format.match(placeholder);
    switch (m ? m[1] : 'amount') {
      case 'amount': value = delimit(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': value = delimit(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = delimit(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delimit(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = delimit(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = delimit(cents, 2, ' ', '.'); break;
      case 'amount_with_apostrophe_separator': value = delimit(cents, 2, "'", '.'); break;
      default: value = delimit(cents, 2, ',', '.');
    }
    return format.replace(placeholder, value);
  }
  function money(cents) { return formatMoney(Math.round(cents || 0), S.moneyFormat); }
  var TP = TWK.product || {};
  // pack discount: per product (buy box setting) or theme default; shop currency → visitor currency
  var packDiscount = Math.round(((TP.packDiscount != null) ? TP.packDiscount : (S.packDiscount || 0)) * RATE);
  var packLabel = TP.packLabel || S.packDiscountTitle || 'Couple Pack';

  /* ---------- Header ---------- */
  var header = $('.tw-header');
  function onScroll() { if (header) header.classList.toggle('is-scrolled', window.scrollY > 8); }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- Panels (cart / menu) ---------- */
  function closePanels() { document.body.classList.remove('cart-open', 'menu-open'); }
  $$('.tw-overlay').forEach(function (o) { o.addEventListener('click', closePanels); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanels(); });
  $$('[data-open-cart]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openCart(); }); });
  $$('[data-close-panels]').forEach(function (b) { b.addEventListener('click', closePanels); });
  $$('[data-open-menu]').forEach(function (b) { b.addEventListener('click', function () { document.body.classList.add('menu-open'); }); });
  $$('.tw-mnav a').forEach(function (a) { a.addEventListener('click', closePanels); });

  /* ---------- Projector animation: light switch ---------- */
  $$('[data-proj-toggle]').forEach(function (btn) {
    var room = btn.closest('section') && btn.closest('section').querySelector('[data-proj-room]');
    var label = btn.querySelector('[data-proj-label]');
    btn.addEventListener('click', function () {
      if (!room) return;
      var lit = room.classList.toggle('is-lit');
      btn.setAttribute('aria-pressed', lit ? 'true' : 'false');
      if (label) label.textContent = lit ? btn.getAttribute('data-label-off') : btn.getAttribute('data-label-on');
    });
  });

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.tw-reveal').forEach(function (el) { io.observe(el); });
  } else {
    $$('.tw-reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- Delivery dates ---------- */
  var lang = (S.locale || document.documentElement.lang || 'en').slice(0, 2);
  var monthFmt;
  try { monthFmt = new Intl.DateTimeFormat(lang, { month: 'long' }); } catch (e) { monthFmt = new Intl.DateTimeFormat('en', { month: 'long' }); }
  function addBusinessDays(date, n) {
    var d = new Date(date.getTime());
    while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; }
    return d;
  }
  function rangeText(a, b) {
    var ma = monthFmt.format(a), mb = monthFmt.format(b);
    if (ma === mb) return t('eta_same', { d1: a.getDate(), d2: b.getDate(), month: mb }, 'between {month} {d1} and {d2}');
    return t('eta_diff', { d1: a.getDate(), d2: b.getDate(), month1: ma, month2: mb }, 'between {month1} {d1} and {month2} {d2}');
  }
  (function delivery() {
    var today = new Date(); today.setHours(12, 0, 0, 0);
    var day0 = new Date(today.getTime()); day0.setHours(0, 0, 0, 0);
    var dayFmt;
    try { dayFmt = new Intl.DateTimeFormat(lang, { month: 'long', day: 'numeric' }); } catch (e) { dayFmt = null; }
    // production days of made-to-order products are added to the shipping time
    $$('[data-eta]').forEach(function (el) {
      var box = el.closest('[data-processing]');
      var extra = box ? parseInt(box.getAttribute('data-processing'), 10) || 0 : 0;
      el.textContent = rangeText(addBusinessDays(today, (S.deliveryMin || 8) + extra), addBusinessDays(today, (S.deliveryMax || 15) + extra));
    });
    $$('[data-xmas-line]').forEach(function (line) {
      var dateEl = $('[data-cutoff-date]', line);
      var iso = (dateEl && dateEl.getAttribute('data-cutoff-date')) || S.cutoff;
      if (!iso) return;
      var cut = new Date(iso + 'T00:00:00');
      if (isNaN(cut)) return;
      if (dateEl && dayFmt) dateEl.textContent = dayFmt.format(cut);
      var days = Math.round((cut - day0) / 86400000);
      $$('[data-cutoff-num]', line).forEach(function (el) { el.textContent = Math.max(days, 0); });
      $$('[data-cutoff-days]', line).forEach(function (el) {
        el.textContent = days > 1 ? t('days_left', { n: days }, '{n} days left') : (days >= 0 ? t('last_day', null, 'Last day') : '');
      });
      if (days < 0) line.hidden = true;
    });
  })();

  /* ==========================================================================
     Gallery
     ========================================================================== */
  var track = $('[data-gallery-track]');
  var thumbs = $$('[data-thumb]');
  var dotsWrap = $('[data-gallery-dots]');
  var slides = track ? $$('.tw-slide', track) : [];
  var current = 0;

  if (dotsWrap && slides.length > 1) {
    slides.forEach(function (_, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', String(i + 1));
      b.addEventListener('click', function () { goTo(i); });
      dotsWrap.appendChild(b);
    });
  }
  function setActive(i) {
    current = i;
    thumbs.forEach(function (th, j) { th.classList.toggle('is-active', j === i); th.setAttribute('aria-current', j === i ? 'true' : 'false'); });
    if (dotsWrap) $$('button', dotsWrap).forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
    var at = thumbs[i];
    if (at && at.parentNode) {
      var p = at.parentNode;
      if (at.offsetTop < p.scrollTop || at.offsetTop + at.offsetHeight > p.scrollTop + p.clientHeight) p.scrollTo({ top: at.offsetTop - 10, behavior: 'smooth' });
    }
  }
  function goTo(i, instant) {
    if (!track || !slides.length) return;
    i = (i + slides.length) % slides.length;
    track.scrollTo({ left: slides[i].offsetLeft, behavior: instant ? 'auto' : 'smooth' });
    setActive(i);
  }
  if (track) {
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== current) setActive(i);
      });
    }, { passive: true });
    setActive(0);
  }
  thumbs.forEach(function (th, i) { th.addEventListener('click', function () { goTo(i); }); });
  $$('[data-gallery-prev]').forEach(function (b) { b.addEventListener('click', function () { goTo(current - 1); }); });
  $$('[data-gallery-next]').forEach(function (b) { b.addEventListener('click', function () { goTo(current + 1); }); });

  /* ==========================================================================
     Product: design + pack
     ========================================================================== */
  var P = TWK.product;
  var form = $('[data-product-form]');
  var state = { variant: null, pack: 1, picks: [null, null] };

  function variantById(id) {
    if (!P) return null;
    id = String(id);
    for (var i = 0; i < P.variants.length; i++) if (String(P.variants[i].id) === id) return P.variants[i];
    return null;
  }
  function currentTotal() {
    if (state.pack === 2) {
      var a = variantById(state.picks[0]) || state.variant, b = variantById(state.picks[1]) || state.variant;
      return a.price + b.price - packDiscount;
    }
    return state.variant.price;
  }

  function render() {
    if (!form || !state.variant) return;
    var total = currentTotal();
    var label = state.variant.label != null ? state.variant.label : state.variant.title;
    $$('[data-design-label]').forEach(function (el) { el.textContent = label; });
    $$('[data-price]').forEach(function (el) { el.textContent = money(total); });
    $$('[data-atc-price]').forEach(function (el) { el.textContent = money(total); });
    $$('[data-unit-price]').forEach(function (el) { el.textContent = money(state.variant.price); });
    $$('[data-pack-price]').forEach(function (el) { el.textContent = money(state.variant.price * 2 - packDiscount); });
    $$('[data-pack-save]').forEach(function (el) { el.textContent = t('save', { amount: money(packDiscount) }, 'You save {amount}'); });
    $$('[data-save]').forEach(function (el) {
      el.hidden = state.pack !== 2;
      el.textContent = t('save', { amount: money(packDiscount) }, 'You save {amount}');
    });
    var pick = $('[data-pack-pick]');
    if (pick) pick.hidden = state.pack !== 2;
    $$('[data-sticky-meta]').forEach(function (el) {
      el.textContent = [state.pack === 2 ? packLabel : '', label, money(total)].filter(Boolean).join(' · ');
    });
    $$('[data-sticky-img]').forEach(function (el) { if (state.variant.thumb) el.src = state.variant.thumb; });
    var hid = $('input[name="id"]', form);
    if (hid) hid.value = state.variant.id;
    var avail = state.variant.available !== false;
    $$('[data-atc]').forEach(function (b) { b.disabled = !avail; });
    $$('[data-atc-label]').forEach(function (el) { el.textContent = avail ? t('add_to_cart', null, 'Add to cart') : t('sold_out', null, 'Sold out'); });
  }

  function selectVariant(id, opts) {
    var v = variantById(id);
    if (!v) return;
    state.variant = v;
    var radio = $('input[name="design"][value="' + v.id + '"]', form);
    if (radio && !radio.checked) radio.checked = true;
    $$('select[data-pick]', form).forEach(function (sel, i) { sel.value = v.id; state.picks[i] = String(v.id); });
    if (!(opts && opts.keepGallery) && typeof v.mediaIndex === 'number' && v.mediaIndex >= 0) goTo(v.mediaIndex);
    if (!PREVIEW && !(opts && opts.initial) && window.history && history.replaceState) {
      var url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url.toString());
    }
    render();
  }

  if (form && P) {
    $$('input[name="design"]', form).forEach(function (r) {
      r.addEventListener('change', function () { selectVariant(r.value); });
    });
    $$('input[name="pack"]', form).forEach(function (r) {
      r.addEventListener('change', function () { state.pack = parseInt(r.value, 10) || 1; render(); });
    });
    $$('select[data-pick]', form).forEach(function (sel, i) {
      sel.addEventListener('change', function () { state.picks[i] = sel.value; render(); });
    });
    var startId = (new URLSearchParams(location.search)).get('variant');
    var checked = $('input[name="design"]:checked', form);
    var initial = startId && variantById(startId) ? startId : (checked ? checked.value : P.variants[0].id);
    selectVariant(initial, { keepGallery: !startId, initial: true });
    if (/[?&]pack=2(&|$)/.test(location.search)) {
      var packRadio = $('input[name="pack"][value="2"]', form);
      if (packRadio) { packRadio.checked = true; state.pack = 2; render(); }
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(); });
  }

  $$('[data-choose-variant]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      selectVariant(b.getAttribute('data-choose-variant'));
      var target = $('#buy');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
  $$('[data-choose-pack]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      var r = $('input[name="pack"][value="' + b.getAttribute('data-choose-pack') + '"]');
      if (!r) return;
      e.preventDefault();
      r.checked = true; r.dispatchEvent(new Event('change'));
      var target = $('#buy');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* ---------- Home: gift set prices in the visitor's currency ---------- */
  $$('[data-set]').forEach(function (el) {
    var unit = parseInt(el.getAttribute('data-unit'), 10) || 0;
    var units = parseInt(el.getAttribute('data-units'), 10) || 2;
    var disc = Math.round((parseFloat(el.getAttribute('data-discount')) || 0) * 100 * RATE);
    var price = $('[data-set-price]', el), compare = $('[data-set-compare]', el), save = $('[data-set-save]', el);
    if (price) price.textContent = money(unit * units - disc);
    if (compare) compare.textContent = money(unit * units);
    if (save) save.textContent = t('save', { amount: money(disc) }, 'You save {amount}');
  });

  /* ==========================================================================
     Photo upload + crystal globe preview (personalised products)
     ========================================================================== */
  var upInput = form ? $('[data-upload-input]', form) : null;
  var upBox = upInput ? upInput.closest('[data-upload]') : null;
  var engraveInput = form ? $('[data-engrave-input]', form) : null;
  var textInputs = $$('[data-globe-text-input]');
  var live = $('[data-globe-live]');
  var photo = null; // the customer's photo (Image)
  var photoUrl = null;

  // Draws a photo as a laser engraving: bright points on a transparent canvas, faded towards the edge of the globe.
  function engrave(canvas, img, withText) {
    var W = canvas.width, H = canvas.height;
    var off = document.createElement('canvas'); off.width = W; off.height = H;
    var o = off.getContext('2d');
    o.fillStyle = '#000'; o.fillRect(0, 0, W, H);
    var box = W * 0.7, cx = W / 2, cy = H * (withText ? 0.44 : 0.5);
    var iw = img.naturalWidth || img.width, ih = img.naturalHeight || img.height;
    var sc = Math.max(box / iw, box / ih);
    o.drawImage(img, cx - iw * sc / 2, cy - ih * sc / 2, iw * sc, ih * sc);
    var d;
    try { d = o.getImageData(0, 0, W, H); } catch (e) { return false; } // photo from another domain without CORS
    var px = d.data, n = W * H, lum = new Float32Array(n), hist = new Uint32Array(256), count = 0, r0 = box / 2;
    var i, x, y, k;
    for (i = 0; i < n; i++) {
      var l = px[i * 4] * 0.299 + px[i * 4 + 1] * 0.587 + px[i * 4 + 2] * 0.114;
      lum[i] = l;
      x = i % W; y = (i / W) | 0;
      if ((x - cx) * (x - cx) + (y - cy) * (y - cy) < r0 * r0) { hist[l | 0]++; count++; }
    }
    // auto levels on the area that will be engraved
    var lo = 0, hi = 255, acc = 0;
    for (k = 0; k < 256; k++) { acc += hist[k]; if (acc > count * 0.02) { lo = k; break; } }
    acc = 0;
    for (k = 255; k >= 0; k--) { acc += hist[k]; if (acc > count * 0.01) { hi = k; break; } }
    if (hi - lo < 40) { lo = Math.max(0, lo - 20); hi = Math.min(255, hi + 20); }
    var ctx = canvas.getContext('2d'), out = ctx.createImageData(W, H), q = out.data, seed = 11;
    function rnd() { seed = (seed * 16807) % 2147483647; return seed / 2147483647; }
    for (i = 0; i < n; i++) {
      x = i % W; y = (i / W) | 0;
      var dist = Math.sqrt((x - cx) * (x - cx) + (y - cy) * (y - cy)) / r0;
      var fade = dist < 0.82 ? 1 : dist > 1.04 ? 0 : 1 - (dist - 0.82) / 0.22;
      if (!fade) continue;
      var v = (lum[i] - lo) / (hi - lo);
      if (v <= 0.03) continue;
      if (v > 1) v = 1;
      v = Math.pow(v, 1.15) * fade;
      var a = rnd() < 0.3 + 0.7 * v ? v : v * 0.2; // grain, like engraved points
      a *= 0.78 + 0.22 * rnd();
      q[i * 4] = 255; q[i * 4 + 1] = 241; q[i * 4 + 2] = 214; q[i * 4 + 3] = Math.min(255, a * 290);
    }
    ctx.putImageData(out, 0, 0);
    return true;
  }

  function engraveText() {
    var v = engraveInput ? engraveInput.value : (textInputs[0] ? textInputs[0].value : '');
    return v.trim();
  }

  function drawGlobe(g) {
    var c = $('[data-globe-art]', g), sample = $('[data-globe-sample]', g);
    var img = photo || (sample && sample.complete && sample.naturalWidth ? sample : null);
    var txt = engraveText();
    $$('[data-globe-text]', g).forEach(function (el) { el.textContent = txt; });
    g.classList.toggle('has-text', !!txt);
    if (!c || !img) return;
    var ok = engrave(c, img, !!txt);
    g.classList.toggle('has-art', ok !== false);
    g.classList.toggle('has-photo', !!photo && ok !== false);
  }
  function drawAll() { $$('[data-globe]').forEach(drawGlobe); }

  $$('[data-globe-sample]').forEach(function (img) {
    var g = img.closest('[data-globe]');
    if (img.complete && img.naturalWidth) drawGlobe(g);
    else img.addEventListener('load', function () { if (!photo) drawGlobe(g); });
  });

  function uploadError(msg) {
    if (!upBox) { if (msg) alert(msg); return; }
    var el = $('[data-upload-error]', upBox);
    if (el) { el.textContent = msg || ''; el.hidden = !msg; }
    upBox.classList.toggle('is-error', !!msg);
  }

  function useFile(file) {
    if (!file) return;
    var max = upBox ? parseFloat(upBox.getAttribute('data-max-mb')) || 10 : 10;
    if (!/^image\/(jpeg|png)$/.test(file.type)) { uploadError(t('photo_type', null, 'Please choose a JPG or PNG photo.')); if (upInput) upInput.value = ''; return; }
    if (file.size > max * 1048576) { uploadError(t('photo_size', { mb: max }, 'This photo is over {mb} MB. Please choose a smaller one.')); if (upInput) upInput.value = ''; return; }
    uploadError('');
    if (photoUrl) URL.revokeObjectURL(photoUrl);
    photoUrl = URL.createObjectURL(file);
    var img = new Image();
    img.onload = function () {
      photo = img;
      drawAll();
      if (live) live.hidden = false;
    };
    img.onerror = function () { uploadError(t('photo_type', null, 'Please choose a JPG or PNG photo.')); };
    img.src = photoUrl;
    if (upBox) {
      upBox.classList.add('has-photo');
      var th = $('[data-upload-thumb]', upBox); if (th) { th.src = photoUrl; th.hidden = false; }
      var nm = $('[data-upload-name]', upBox); if (nm) nm.textContent = t('photo_added', null, 'Photo added') + ' ✓';
      var ch = $('[data-upload-change]', upBox); if (ch) ch.hidden = false;
      var see = $('[data-upload-see]', upBox); if (see) see.hidden = false;
    }
  }

  if (upInput) upInput.addEventListener('change', function () { useFile(upInput.files && upInput.files[0]); });
  $$('[data-globe-file]').forEach(function (inp) {
    inp.addEventListener('change', function () {
      var f = inp.files && inp.files[0];
      if (!f) return;
      // the photo goes with the order from the buy box field
      if (upInput) { try { var dt = new DataTransfer(); dt.items.add(f); upInput.files = dt.files; } catch (e) {} }
      useFile(f);
      inp.value = '';
    });
  });

  var textTimer;
  function onText(src) {
    var v = src.value;
    if (engraveInput && engraveInput !== src) engraveInput.value = v.slice(0, engraveInput.maxLength > 0 ? engraveInput.maxLength : 40);
    textInputs.forEach(function (el) { if (el !== src) el.value = v; });
    clearTimeout(textTimer);
    textTimer = setTimeout(drawAll, 120);
  }
  if (engraveInput) engraveInput.addEventListener('input', function () { onText(engraveInput); });
  textInputs.forEach(function (el) {
    if (engraveInput && engraveInput.maxLength > 0) el.maxLength = engraveInput.maxLength;
    el.addEventListener('input', function () { onText(el); });
  });
  $$('[data-globe-live-close]').forEach(function (b) { b.addEventListener('click', function () { if (live) live.hidden = true; }); });

  function photoMissing() {
    if (!upInput || (upInput.files && upInput.files.length)) return false;
    uploadError(t('photo_required', null, 'Please add your photo first.'));
    if (upBox) upBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return true;
  }

  // line item properties (personalisation) of the buy box
  function lineProperties() {
    var props = [];
    if (!form) return props;
    $$('[name^="properties["]', form).forEach(function (inp) {
      if (inp.type === 'file') { if (inp.files && inp.files[0]) props.push([inp.name, inp.files[0]]); }
      else if (inp.value.trim()) props.push([inp.name, inp.value.trim()]);
    });
    return props;
  }

  /* ==========================================================================
     Cart
     ========================================================================== */
  var mock = { items: [], n: 0 }; // preview only

  function mockCart() {
    var items = mock.items.map(function (l) {
      var v = variantById(l.id);
      return { key: l.key, id: l.id, quantity: l.qty, product_title: P.title, variant_title: v.label || v.title, image: v.thumb,
        properties: l.props || {}, original_line_price: v.price * l.qty, final_line_price: v.price * l.qty };
    });
    var qty = items.reduce(function (s, l) { return s + l.quantity; }, 0);
    var subtotal = items.reduce(function (s, l) { return s + l.original_line_price; }, 0);
    var discount = qty >= 2 ? packDiscount : 0;
    return { items: items, item_count: qty, total_discount: discount, total_price: subtotal - discount,
      cart_level_discount_applications: discount ? [{ title: packLabel }] : [] };
  }

  function fetchCart() {
    if (PREVIEW) return Promise.resolve(mockCart());
    return fetch(R.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function cartItemsForSelection() {
    if (state.pack === 2) {
      var a = String(state.picks[0] || state.variant.id), b = String(state.picks[1] || state.variant.id);
      return a === b ? [{ id: a, quantity: 2 }] : [{ id: a, quantity: 1 }, { id: b, quantity: 1 }];
    }
    return [{ id: String(state.variant.id), quantity: 1 }];
  }

  function addToCart(opts) {
    if (!state.variant) return Promise.resolve();
    if (photoMissing()) return Promise.resolve();
    var btns = $$('[data-atc]');
    btns.forEach(function (b) { b.classList.add('is-loading'); b.disabled = true; });
    var items = cartItemsForSelection();
    var props = lineProperties();
    var done = function () { btns.forEach(function (b) { b.classList.remove('is-loading'); b.disabled = false; }); };
    var p;
    if (PREVIEW) {
      items.forEach(function (it) {
        if (props.length) { // each personalised globe is its own line
          var pp = {};
          props.forEach(function (kv) { pp[kv[0].slice(11, -1)] = typeof kv[1] === 'string' ? kv[1] : photoUrl; });
          mock.items.push({ key: 'p' + (++mock.n), id: it.id, qty: it.quantity, props: pp });
          return;
        }
        var ex = mock.items.filter(function (l) { return !l.props && String(l.id) === String(it.id); })[0];
        if (ex) ex.qty += it.quantity; else mock.items.push({ key: String(it.id), id: it.id, qty: it.quantity });
      });
      p = new Promise(function (res) { setTimeout(res, 450); });
    } else {
      var req;
      if (props.length && items.length === 1) {
        // personalised line: multipart form, so the photo is uploaded with the line item
        var fd = new FormData();
        fd.append('id', items[0].id);
        fd.append('quantity', items[0].quantity);
        props.forEach(function (kv) { fd.append(kv[0], kv[1]); });
        req = { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd };
      } else {
        req = { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) };
      }
      p = fetch(R.cart_add + '.js', req)
        .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Error'); }); });
    }
    return p.then(function () {
      done();
      if (opts && opts.checkout && !PREVIEW) { location.href = R.checkout; return; }
      openCart();
    }).catch(function (err) { done(); alert(err.message || t('error_add', null, 'Could not add to cart.')); });
  }
  $$('[data-buy-now]').forEach(function (b) { b.addEventListener('click', function () { addToCart({ checkout: true }); }); });

  function changeLine(key, qty) {
    if (PREVIEW) {
      mock.items = mock.items.map(function (l) { if (String(l.key) === String(key)) l.qty = qty; return l; }).filter(function (l) { return l.qty > 0; });
      return Promise.resolve();
    }
    return fetch(R.cart_change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) });
  }

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function discountTitle(cart) {
    var app = (cart.cart_level_discount_applications || [])[0];
    if (app && app.title) return app.title;
    for (var i = 0; i < (cart.items || []).length; i++) {
      var al = (cart.items[i].line_level_discount_allocations || [])[0];
      if (al && al.discount_application && al.discount_application.title) return al.discount_application.title;
    }
    return t('discount', null, 'Discount');
  }

  function renderCart(cart) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.classList.toggle('has-items', cart.item_count > 0); });
    var list = $('[data-cart-items]');
    if (!list) return;
    if (!cart.items.length) {
      list.innerHTML = '<div class="tw-drawer__empty"><p>' + esc(t('cart_empty', null, 'Your cart is empty.')) + '</p></div>';
    } else {
      list.innerHTML = cart.items.map(function (l) {
        var orig = l.original_line_price !== l.final_line_price ? '<s>' + money(l.original_line_price) + '</s>' : '';
        var vt = l.variant_title && l.variant_title !== 'Default Title' ? l.variant_title : '';
        var pr = l.properties || {};
        var props = Object.keys(pr).filter(function (k) { return k.charAt(0) !== '_' && pr[k]; }).map(function (k) {
          var v = String(pr[k]);
          var val = /^(https?:|blob:)/.test(v) || v.indexOf('/uploads/') > -1
            ? '<a href="' + esc(v) + '" target="_blank" rel="noopener">' + esc(t('photo_view', null, 'view')) + '</a> \u2713' : esc(v);
          return '<div class="tw-line__prop">' + esc(k) + ': ' + val + '</div>';
        }).join('');
        return '<div class="tw-line">' +
          '<span class="tw-line__img">' + (l.image ? '<img src="' + esc(l.image) + '" alt="" width="76" height="76">' : '') + '</span>' +
          '<div><div class="tw-line__name">' + esc(l.product_title) + '</div>' +
          '<div class="tw-line__variant">' + esc(vt) + '</div>' + props +
          '<div class="tw-qty"><button type="button" data-qty="' + esc(l.key) + '" data-to="' + (l.quantity - 1) + '" aria-label="' + esc(t('remove_one', null, 'Remove one')) + '">−</button><span>' + l.quantity + '</span><button type="button" data-qty="' + esc(l.key) + '" data-to="' + (l.quantity + 1) + '" aria-label="' + esc(t('add_one', null, 'Add one')) + '">+</button></div></div>' +
          '<div class="tw-line__price">' + orig + money(l.final_line_price) + '</div></div>';
      }).join('');
      $$('[data-qty]', list).forEach(function (b) {
        b.addEventListener('click', function () {
          changeLine(b.getAttribute('data-qty'), parseInt(b.getAttribute('data-to'), 10)).then(fetchCart).then(renderCart);
        });
      });
    }
    var subtotal = cart.items.reduce(function (s, l) { return s + l.original_line_price; }, 0);
    var disc = subtotal - cart.total_price;
    var sub = $('[data-cart-subtotal]'); if (sub) sub.textContent = money(subtotal);
    var discRow = $('[data-cart-discount-row]');
    if (discRow) {
      discRow.hidden = disc <= 0;
      var dl = $('[data-cart-discount]'); if (dl) dl.textContent = '−' + money(disc);
      var dt = $('[data-cart-discount-title]'); if (dt) dt.textContent = discountTitle(cart);
    }
    var tot = $('[data-cart-total]'); if (tot) tot.textContent = money(cart.total_price);

    var th = S.freeShipping || 0;
    var msg = $('[data-ship-msg]'), bar = $('[data-ship-bar]'), wrap = $('[data-ship]');
    if (wrap) wrap.hidden = !th;
    if (th && msg && bar) {
      var left = th - cart.total_price;
      msg.innerHTML = cart.item_count === 0 ? t('ship_start', { amount: '<strong>' + money(th) + '</strong>' }, 'Free shipping on orders over {amount}')
        : left > 0 ? t('ship_progress', { amount: '<strong>' + money(left) + '</strong>' }, "You're {amount} away from free shipping")
        : t('ship_unlocked', null, "<strong>You've unlocked free shipping!</strong> ✦");
      bar.style.width = Math.min(100, Math.round(cart.total_price / th * 100)) + '%';
    }
  }

  function openCart() {
    if (!$('.tw-drawer')) { location.href = R.cart; return; }
    fetchCart().then(function (c) { renderCart(c); document.body.classList.add('cart-open'); });
  }
  fetchCart().then(renderCart).catch(function () {});

  /* ---------- Sticky buy bar ---------- */
  var sticky = $('[data-sticky]');
  var buyBox = $('.tw-buy');
  var footer = $('.tw-footer');
  if (sticky && buyBox && 'IntersectionObserver' in window) {
    var past = false, nearFooter = false;
    var update = function () { sticky.classList.toggle('is-visible', past && !nearFooter); };
    new IntersectionObserver(function (en) { past = !en[0].isIntersecting && en[0].boundingClientRect.top < 0; update(); }).observe(buyBox);
    if (footer) new IntersectionObserver(function (en) { nearFooter = en[0].isIntersecting; update(); }).observe(footer);
  }
  $$('[data-sticky-atc]').forEach(function (b) { b.addEventListener('click', function () { addToCart(); }); });
})();
